import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Zap } from "lucide-react";

export default function OurFeatures() {
  const { ref, isVisible } = useScrollReveal();

  const features = [
    {
      icon: Zap,
      iconType: "component",
      title: "Daily YouTube Payouts",
      description: "No more waiting months for your earnings. Maintain consistent cash flow for your creator business without the delay.",
      gradient: "linear-gradient(137.738deg, rgb(0, 166, 86) 2.173%, rgb(9, 145, 41) 52.175%, rgb(18, 126, 0) 97.827%)",
    },
    {
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/early-pay.svg",
      iconType: "svg",
      title: "Early Pay and Advances",
      description: "Access your earnings before they're due. Perfect for funding new projects, covering expenses, or seizing opportunities.",
      gradient: "linear-gradient(137.738deg, rgb(96, 165, 250) 2.173%, rgb(59, 130, 246) 97.827%)",
    },
    {
      icon: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/card.svg",
      iconType: "svg",
      title: "Multiple Payment Methods",
      description: "PayPal, wire transfer, crypto—choose what works best for you. Global payment support for creators worldwide.",
      gradient: "linear-gradient(137.738deg, rgb(167, 139, 250) 2.173%, rgb(139, 92, 246) 97.827%)",
    },
  ];

  return (
    <div
      id="our-features"
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-12 xl:px-18 1xl:px-0 2xl:px-0 4xl:px-16`}
    >
      <div className="mx-auto max-w-7xl">
        {/* Label */}
        <p className="text-[#757575] text-[18px] 4xl:text-[24px] font-medium text-left mb-6">
          Our Features
        </p>

        {/* Main Heading */}
        <h1 className="text-5xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal text-black text-left leading-[106px] xxs:leading-tight xs:leading-tight sm:leading-tight md:leading-tight lg:leading-normal mb-6 enfinity-header-font">
          <span className="text-[#00A656] enfinity-header-font">Everything you need</span>
          <span> to manage payments</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl xxs:text-[1rem] lg:text-[24px] font-normal text-black text-left leading-[34px] mb-12 max-w-[728px] enfinity-subtext-font">
          Powerful payment tools built specifically for YouTube creators who want financial flexibility and control.
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
          {features.map((feature, index) => {
            const Icon = feature.iconType === "component" ? feature.icon : null;
            return (
              <div
                key={index}
                className="bg-white border border-[#eee] rounded-[20px] shadow-[0px_2px_6px_0px_rgba(144,146,148,0.1)] h-[360px] xxs:h-[380px] xs:h-[340px] sm:h-[340px] md:h-[360px] lg:h-[530px] xl:h-[430px] p-6 lg:p-[39px] flex flex-col"
              >
                {/* Icon Box */}
                <div 
                  className="rounded-[20px] w-[70px] h-[70px] lg:w-[85px] lg:h-[85px] flex items-center justify-center mb-6 lg:mb-[38px] flex-shrink-0"
                  style={{ backgroundImage: feature.gradient }}
                >
                  {feature.iconType === "component" ? (
                    <Icon className="w-[40px] h-[40px] lg:w-[50px] lg:h-[50px] text-white" strokeWidth={1} />
                  ) : (
                    <img src={feature.icon} alt={feature.title} className="w-[40px] h-[40px] lg:w-[50px] lg:h-[50px] object-contain" />
                  )}
                </div>

                {/* Title */}
                <h3 className="text-[24px] lg:text-[23px] 1xl:text-[25px] font-normal text-black mb-3 lg:mb-4 leading-normal enfinity-header-font">
                  {feature.title}
                </h3>

                {/* Description */}
                <p className="text-base xxs:text-[1rem] lg:text-[20px] font-normal text-black leading-[28px] lg:leading-[32px] enfinity-subtext-font">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

